
import { create } from "zustand";
import axios from "axios";
import { API_BASE_URL1 } from "../../../Services/baseApiUrl";
import { apiCall } from "../../../../utils/apiCall";
import { toast } from "react-toastify";

const useIndependentStore = create((set, get) => ({
    independentEngineerData: [],
    ieNameList: [],
    loading: false,
    error: false,
    selectedIEName: "",
    selectedStatus: "", // Ensure this state exists

    setSelectedIEName: (ieName) => set({ selectedIEName: ieName }),
    setStatus: (status) => set({ selectedStatus: status }),

    fetchindependentEngineerData: async (queryParams) => {
        set({ loading: true, error: null });
        const queryString = new URLSearchParams(queryParams).toString();
        try {
            const iEData = await apiCall({
                url: `${API_BASE_URL1}IEMasterDetails/GetIndependentEngineers?${queryString}`,
                method: "get",
                token: localStorage.getItem("token"),
            });
    
            set({ 
                independentEngineerData: Array.isArray(iEData) ? iEData : [], 
                loading: false 
            });
            set((state) => ({
                ieNameList: state.ieNameList.length ? state.ieNameList : iEData.map((eng) => eng.name),
            }));
    
        } catch (error) {
            console.log(error.response?.data?.message || "Error fetching data");

            if (error.response && error.response.status === 404) {
                set({ 
                    independentEngineerData: [], 
                    filteredObservations: [], 
                    error: "No hygiene observations found.", 
                    loading: false 
                });
            } else {
                set({ error: error.response?.data?.message || "Something went wrong", loading: false });
            }
        } finally {
            set({ loading: false });
        }
    },
      // Create a New Independent Engineer with Validation Handling
      addNewIndependentEngineer: async (newIE) => {
                set({  error: null });
        
                try {
                    const response = await axios.post(
                         `${API_BASE_URL1}IEMasterCreate/AddNewIndependentEngineer`,(newIE),
                         {
                            headers: {
                                "Content-Type": "multipart/form-data",
                                Authorization: `Bearer ${localStorage.getItem("token")}`,
                            },
                        }
                    );
        
                    set((state) => ({
                        independentEngineerData: [...state.independentEngineerData, response],
                        loading: false
                    }));
        
                    toast.success("Independent Engineer added successfully!"); 
                    return { success: true };
        
                } catch (error) {
                    console.error("Error adding Independent Engineer:", error.response?.data || error.message);
        
                    if (error.response?.status === 400) { 
                        const validationErrors = error.response.data.errors || error.response.data;
        
                        if (typeof validationErrors === "object") {
                            let errorMessages = [];
        
                            Object.keys(validationErrors).forEach((key) => {
                                if (Array.isArray(validationErrors[key])) {
                                    validationErrors[key].forEach((msg) => {
                                        errorMessages.push(msg);
                                    });
                                } else {
                                    errorMessages.push(validationErrors[key]);
                                }
                            });
        
                            errorMessages.forEach((msg) => toast.error(msg));
                            return { success: false, errors: validationErrors };
                        }
                    }
        
                    // Handle general errors
                    const errorMessage = error.response?.data || "Failed to add Independent Engineer";
                    toast.error(errorMessage);
                    set({ error: errorMessage, loading: false });
        
                    return { success: false, errors: { general: errorMessage } };
                }
                finally {
                    set({ loading: false });
                }
            },
        
        
            // Update a existing Transferstation Category with Validation Handling
            UpdateIndependentEngineerData: async (updateObservation) => {
                set({  error: null });
        
                try {
                    const response = await apiCall({
                        url: `${API_BASE_URL1}IEMasterCreate/UpdateIndependentEngineerDetails`,
                        method: "put",
                        token: localStorage.getItem("token"),
                        data: updateObservation,
                    });
        
                    set((state) => ({
                        independentEngineerData: [...state.independentEngineerData, response],
                        loading: false
                    }));
        
        
                    toast.success("Independent Engineer Updated successfully!");
                    return { success: true };
        
                } catch (error) {
                    console.log(error)
                    console.error("Error adding Independent Engineer:", error.response?.data || error.message);
        
                    if (error.response?.status === 400) { 
                        const validationErrors = error.response.data.errors || error.response.data;
        
                        if (typeof validationErrors === "object") {
                            let errorMessages = [];
        
                            Object.keys(validationErrors).forEach((key) => {
                                if (Array.isArray(validationErrors[key])) {
                                    validationErrors[key].forEach((msg) => {
                                        errorMessages.push(msg);
                                    });
                                } else {
                                    errorMessages.push(validationErrors[key]);
                                }
                            });
        
                            errorMessages.forEach((msg) => toast.error(msg));
                            return { success: false, errors: validationErrors };
                        }
                    }
        
                    // Handle general errors
                    const errorMessage = error.response?.data || "Failed to add Independent Engineer";
                    toast.error(errorMessage);
                    set({ error: errorMessage, loading: false });
        
                    return { success: false, errors: { general: errorMessage } };
                }
                finally {
                    set({ loading: false });
                }
            },


            deleteIndependentEngineerStore: async (deleteIeId) => {
                set({ loading: true, error: null });
        
                try {
                    const response = await apiCall({
                        url: `${API_BASE_URL1}IEMasterCreate/DeleteIndependentEngineer/${deleteIeId}`,
                        method: "delete",
                        token: localStorage.getItem("token"),
                        data: { id: deleteIeId }, 
                        // headers: { "Content-Type": "application/json" },
                    });
                    
        
                    set((state) => ({
                        independentEngineerData: [...state.independentEngineerData, response],
                        loading: false
                    }));
        
        
                    toast.success("Independent Engineer Deleted successfully!");
                    return { success: true };
        
                } catch (error) {
                    console.error("Error adding Independent Engineer:", error.response?.data || error.message);
        
                    if (error.response?.status === 400) { 
                        const validationErrors = error.response.data.errors || error.response.data;
        
                        if (typeof validationErrors === "object") {
                            let errorMessages = [];
        
                            Object.keys(validationErrors).forEach((key) => {
                                if (Array.isArray(validationErrors[key])) {
                                    validationErrors[key].forEach((msg) => {
                                        errorMessages.push(msg);
                                    });
                                } else {
                                    errorMessages.push(validationErrors[key]);
                                }
                            });
        
                            errorMessages.forEach((msg) => toast.error(msg));
                            return { success: false, errors: validationErrors };
                        }
                    }
        
                    // Handle general errors
                    const errorMessage = error.response?.data || "Failed to delete Independent Engineer";
                    toast.error(errorMessage);
                    set({ error: errorMessage, loading: false });
        
                    return { success: false, errors: { general: errorMessage } };
                }
                finally {
                    set({ loading: false });
                }
            },


}));

export default useIndependentStore;
